<template>
  <div>
    <div class="horizontal-feature">
      <div class="feature-text" :class="{ active: activeTab === 'about' }" @click="changeTab('about')">
        About
      </div>
      <div class="feature-text" :class="{ active: activeTab === 'roadmap' }" @click="changeTab('roadmap')">
        Roadmap
      </div>
      <div class="feature-text" :class="{ active: activeTab === 'regulation' }" @click="changeTab('regulation')">
        Regulation
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalFeature',
  props: {
    activeTab: {
      type: String,
      default: 'about'
    }
  },
  emits: ['update:activeTab'],
  methods: {
    changeTab(tab) {
      this.$emit('update:activeTab', tab);
    }
  }
};
</script>

<style scoped>
.horizontal-feature {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 1.5rem 0;
  background-color: #000;
  gap: 1rem;
  flex-wrap: wrap;
}

.feature-text {
  color: #bababa;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  user-select: none;
}

.feature-text:hover {
  color: #e0c35c;
  background-color: rgba(212, 175, 55, 0.1);
}

.feature-text.active {
  color: #D4AF37 !important;
  background-color: rgba(212, 175, 55, 0.15);
}

/* Responsive Design */
@media (max-width: 768px) {
  .horizontal-feature {
    padding: 1rem 0.5rem;
    gap: 0.5rem;
  }

  .feature-text {
    font-size: 0.95rem;
    padding: 0.4rem 1rem;
  }
}

@media (max-width: 480px) {
  .horizontal-feature {
    flex-direction: column;
    padding: 1rem;
  }

  .feature-text {
    width: 100%;
    text-align: center;
    font-size: 1rem;
    padding: 0.75rem;
  }
}
</style>